/**
 * AddViewModal — the "+ Add view" picker for a Unit in the Building Information Model tool
 * (see ProgramModelModal.jsx and docs/PROGRAM_MODEL.md — "Unit Views"). Gates on the active
 * level's alignment anchor being set (a View's callout can't be projected onto every level of
 * the unit without one) before offering the Elevation/Section choice. Reuses the parent's own
 * `.aj-pm-primarybtn`/`.aj-pm-ghostbtn` hover CSS — that <style> tag is a real DOM element, so it
 * applies here too even though this modal portals to document.body separately.
 */
import { createPortal } from 'react-dom'

const DARK = '#07272D'
const primaryBtnLike = { background: DARK, border: '0.5px solid ' + DARK, color: '#fff', borderRadius: 5, padding: '8px 14px', cursor: 'pointer', fontFamily: '"DM Sans", sans-serif', fontSize: 12.5, fontWeight: 600, width: '100%', textAlign: 'left' }
const ghostBtnLike = { background: 'var(--aj-bg-elevated)', border: '0.5px solid var(--aj-border-mid)', color: 'var(--aj-text-mid)', borderRadius: 5, padding: '4px 11px', cursor: 'pointer', fontFamily: '"DM Sans", sans-serif', fontSize: 11.5, fontWeight: 600, width: '100%', marginTop: 12 }

export default function AddViewModal({ anchorReady, onSetAnchor, onChoose, onClose }) {
  return createPortal(
    <div style={{ position: 'fixed', inset: 0, zIndex: 900, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={onClose}>
      <div onClick={e => e.stopPropagation()} style={{ background: 'var(--aj-bg-surface)', borderRadius: 8, padding: 20, width: 320, boxShadow: '0 8px 32px rgba(0,0,0,0.35)' }}>
        <div style={{ fontFamily: '"Montserrat",sans-serif', fontWeight: 700, fontSize: 12, letterSpacing: '0.06em', textTransform: 'uppercase', color: 'var(--aj-text)', marginBottom: 12 }}>
          Add View
        </div>
        {!anchorReady ? (
          <>
            <div style={{ fontFamily: '"DM Sans",sans-serif', fontSize: 12, color: 'var(--aj-text-mid)', lineHeight: 1.5, marginBottom: 14 }}>
              This level needs an alignment anchor before a view can be placed — a shared point
              (like a building corner) marked once so views land in the same spot on every level.
            </div>
            <button onClick={onSetAnchor} className="aj-pm-primarybtn" style={primaryBtnLike}>Set anchor now</button>
          </>
        ) : (
          <>
            <div style={{ fontFamily: '"DM Sans",sans-serif', fontSize: 12, color: 'var(--aj-text-mid)', lineHeight: 1.5, marginBottom: 14 }}>
              Choose a type, then click on the plan to place its callout.
            </div>
            <button onClick={() => onChoose('elevation')} className="aj-pm-primarybtn" style={primaryBtnLike}>
              Elevation — click a position, then a point setting the direction it looks
            </button>
            <button onClick={() => onChoose('section')} className="aj-pm-primarybtn" style={{ ...primaryBtnLike, marginTop: 8 }}>
              Section — click the cut line's two ends, then the side it looks toward
            </button>
          </>
        )}
        <button onClick={onClose} className="aj-pm-ghostbtn" style={ghostBtnLike}>Cancel</button>
      </div>
    </div>,
    document.body
  )
}
